/* eslint-disable react/no-multi-comp */
import React, { PureComponent } from 'react';
import moment from 'moment';
import {
    LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer
} from 'recharts';
import translation from './lang';
import { ReactComponent as ProfitIcon } from './assets/profit.svg';
import { ReactComponent as SaleIcon } from './assets/sale.svg';
import { ReactComponent as ExpensesIcon } from './assets/expenses.svg';

class CustomizedLabel extends PureComponent {
    render() {
        const {
            x, y, stroke, value,
        } = this.props;
        return <text x={x < 120 ? 120 : x} y={y} dy={-4} fill={stroke} stroke="var(--orange)" fontWeight={100} fontSize={12} textAnchor="middle">{parseInt(value).toLocaleString()}</text>;
    }
}

class CustomizedAxisTick extends PureComponent {
    render() {
        const {
            x, y, payload, period
        } = this.props;

        let text = '';

        if (period === 'current') {
            text = translation[this.props.lang || 'uz'][payload.value.toLowerCase()]
        } else if (period === 'quater') {
            text = translation[this.props.lang || 'uz'][payload.value.toLowerCase()]
        } else if (period === 'semiannual' || period === 'annual') {
            text = translation[this.props.lang || 'uz'].short[payload.value.toLowerCase()]
        } else {
            text = payload.value;
        }
        return (
            <g transform={`translate(${x},${y})`}>
                <text x={0} y={0} dy={16} textAnchor="end" fill="#666" transform="rotate(-35)">{text}</text>
            </g>
        );
    }
}

class Profit extends PureComponent {

    render() {
        const { period, data, currency = "uz", expenses = [], lang = "en" } = this.props;

        let currentData = [];
        if (period === 'current') {

            for (let i = 1; i <= 7; i++) {
                const startDay = moment().weekday(i).hour(0).minute(0).second(0).valueOf();
                const endDay = moment().weekday(i).hour(23).minute(59).second(59).valueOf();
                const currentDayName = moment().weekday(i).format('dddd');

                const thisWeekSale = data.reduce((totalAmount, sale) => {

                    if (sale.updatedAt >= startDay && sale.updatedAt <= endDay) {
                        totalAmount.sale += currency === 'UZS' && sale.currency === 'UZS' ? parseFloat(sale.totalValue) : parseFloat(sale.salePriceAfterExchange);
                        totalAmount.expenses += currency === 'UZS' && sale.currency === 'UZS' ? parseFloat((sale.totalFactoryPrice) * sale.currencyRate) : parseFloat(sale.totalFactoryPrice);
                    }
                    return totalAmount;
                }, { expenses: 0, sale: 0 });

                const thisWeekExpenses = expenses.reduce((totalAmount, sale) => {
                    if (sale.createdAt >= startDay && sale.createdAt <= endDay) {
                        if (currency === 'UZS') {
                            return totalAmount += parseInt(sale.uzsAmount);
                        } else {
                            return totalAmount += parseFloat(sale.usdAmount);
                        }
                    }
                    return totalAmount;
                }, 0);

                const profit = parseInt(thisWeekSale.sale) - (parseInt(thisWeekSale.expenses) + parseInt(thisWeekExpenses));

                currentData.push({ ...thisWeekSale, storeExpenses: parseInt(thisWeekExpenses), name: currentDayName, profit });
            }
        } else if (period === 'month') {
            const numOfDaysInMonth = moment().daysInMonth();
            for (let i = 1; i <= numOfDaysInMonth; i++) {

                const startDay = moment().date(i).hour(0).minute(0).second(0).valueOf();
                const endDay = moment().date(i).hour(23).minute(59).second(59).valueOf();
                const currentDayName = moment().date(i).format('DD');

                // console.log(currentDayName);


                const thisWeekSale = data.reduce((totalAmount, sale) => {

                    if (sale.updatedAt >= startDay && sale.updatedAt <= endDay) {
                        totalAmount.sale += currency === 'UZS' && sale.currency === 'UZS' ? parseFloat(sale.totalValue) : parseFloat(sale.salePriceAfterExchange);
                        totalAmount.expenses += currency === 'UZS' && sale.currency === 'UZS' ? parseFloat((sale.totalFactoryPrice) * sale.currencyRate) : parseFloat(sale.totalFactoryPrice);
                    }
                    return totalAmount;
                }, { expenses: 0, sale: 0 });

                const thisWeekExpenses = expenses.reduce((totalAmount, sale) => {
                    if (sale.createdAt >= startDay && sale.createdAt <= endDay) {
                        if (currency === 'UZS') {
                            return totalAmount += parseInt(sale.uzsAmount);
                        } else {
                            return totalAmount += parseFloat(sale.usdAmount);
                        }
                    }
                    return totalAmount;
                }, 0);

                const profit = parseInt(thisWeekSale.sale) - (parseInt(thisWeekSale.expenses) + parseInt(thisWeekExpenses));

                currentData.push({ ...thisWeekSale, storeExpenses: parseInt(thisWeekExpenses), name: currentDayName, profit });
            }
        } else if (period === 'quater') {

            for (let i = 0; i < 3; i++) {

                const startDay = moment().subtract(i, 'month').startOf('month').valueOf();
                const endDay = moment().subtract(i, 'month').endOf('month').valueOf();
                const currentDayName = moment().subtract(i, 'month').format('MMMM');


                const thisWeekSale = data.reduce((totalAmount, sale) => {

                    if (sale.updatedAt >= startDay && sale.updatedAt <= endDay) {
                        totalAmount.sale += currency === 'UZS' && sale.currency === 'UZS' ? parseFloat(sale.totalValue) : parseFloat(sale.salePriceAfterExchange);
                        totalAmount.expenses += currency === 'UZS' && sale.currency === 'UZS' ? parseFloat((sale.totalFactoryPrice) * sale.currencyRate) : parseFloat(sale.totalFactoryPrice);
                    }
                    return totalAmount;
                }, { expenses: 0, sale: 0 });

                const thisWeekExpenses = expenses.reduce((totalAmount, sale) => {
                    if (sale.createdAt >= startDay && sale.createdAt <= endDay) {
                        if (currency === 'UZS') {
                            return totalAmount += parseInt(sale.uzsAmount);
                        } else {
                            return totalAmount += parseFloat(sale.usdAmount);
                        }
                    }
                    return totalAmount;
                }, 0);

                const profit = parseInt(thisWeekSale.sale) - (parseInt(thisWeekSale.expenses) + parseInt(thisWeekExpenses));

                currentData.unshift({ ...thisWeekSale, storeExpenses: parseInt(thisWeekExpenses), name: currentDayName, profit });
            }
        } else if (period === 'semiannual') {

            for (let i = 0; i < 6; i++) {

                const startDay = moment().subtract(i, 'month').startOf('month').valueOf();
                const endDay = moment().subtract(i, 'month').endOf('month').valueOf();
                const currentDayName = moment().subtract(i, 'month').format('MMMM');

                const thisWeekSale = data.reduce((totalAmount, sale) => {

                    if (sale.updatedAt >= startDay && sale.updatedAt <= endDay) {
                        totalAmount.sale += currency === 'UZS' && sale.currency === 'UZS' ? parseFloat(sale.totalValue) : parseFloat(sale.salePriceAfterExchange);
                        totalAmount.expenses += currency === 'UZS' && sale.currency === 'UZS' ? parseFloat((sale.totalFactoryPrice) * sale.currencyRate) : parseFloat(sale.totalFactoryPrice);
                    }
                    return totalAmount;
                }, { expenses: 0, sale: 0 });

                const thisWeekExpenses = expenses.reduce((totalAmount, sale) => {
                    if (sale.createdAt >= startDay && sale.createdAt <= endDay) {
                        if (currency === 'UZS') {
                            return totalAmount += parseInt(sale.uzsAmount);
                        } else {
                            return totalAmount += parseFloat(sale.usdAmount);
                        }
                    }
                    return totalAmount;
                }, 0);

                const profit = parseInt(thisWeekSale.sale) - (parseInt(thisWeekSale.expenses) + parseInt(thisWeekExpenses));

                currentData.unshift({ ...thisWeekSale, storeExpenses: parseInt(thisWeekExpenses), name: currentDayName, profit });
            }
        } else if (period === 'annual') {

            for (let i = 0; i < 12; i++) {

                const startDay = moment().subtract(i, 'month').startOf('month').valueOf();
                const endDay = moment().subtract(i, 'month').endOf('month').valueOf();
                const currentDayName = moment().subtract(i, 'month').format('MMMM');


                const thisWeekSale = data.reduce((totalAmount, sale) => {

                    if (sale.updatedAt >= startDay && sale.updatedAt <= endDay) {
                        totalAmount.sale += currency === 'UZS' && sale.currency === 'UZS' ? parseFloat(sale.totalValue) : parseFloat(sale.salePriceAfterExchange);
                        totalAmount.expenses += currency === 'UZS' && sale.currency === 'UZS' ? parseFloat((sale.totalFactoryPrice) * sale.currencyRate) : parseFloat(sale.totalFactoryPrice);
                    }
                    return totalAmount;
                }, { expenses: 0, sale: 0 });

                const thisWeekExpenses = expenses.reduce((totalAmount, sale) => {
                    if (sale.createdAt >= startDay && sale.createdAt <= endDay) {
                        if (currency === 'UZS') {
                            return totalAmount += parseInt(sale.uzsAmount);
                        } else {
                            return totalAmount += parseFloat(sale.usdAmount);
                        }
                    }
                    return totalAmount;
                }, 0);

                const profit = parseInt(thisWeekSale.sale) - (parseInt(thisWeekSale.expenses) + parseInt(thisWeekExpenses));

                currentData.unshift({ ...thisWeekSale, storeExpenses: parseInt(thisWeekExpenses), name: currentDayName, profit });
            }
        }

        const widgetData = {
            expenses: currentData.reduce((sum, value) => sum += value.expenses, 0),
            storeExpenses: currentData.reduce((sum, value) => sum += value.storeExpenses, 0),
            profit: currentData.reduce((sum, value) => sum += value.profit, 0),
            sale: currentData.reduce((sum, value) => sum += value.sale, 0),
        }
        console.log(widgetData);

        return (
            <div className="my-5 pb-5" id="dashboard-profit">
                <div className="row">
                    <div className="col-3">
                        <div className="card bg-success text-white mb-4 sale">
                            <div><SaleIcon fill="#fff" strokeWidth="1" /></div>
                            <div className="card-body text-center">
                                <h4>{parseInt(widgetData.sale).toLocaleString()}<sup className="card-currency">{currency}</sup> </h4>
                                <h6 className="mb-0">{translation[lang].sale}</h6>
                            </div>
                        </div>
                    </div>
                    <div className="col-3">
                        <div className="card bg-success text-white mb-4 sale">
                            <div><ExpensesIcon fill="#fff" strokeWidth="1" /></div>
                            <div className="card-body text-center">
                                <h4>{parseInt(widgetData.expenses).toLocaleString()}<sup className="card-currency">{currency}</sup> </h4>
                                <h6 className="mb-0">{translation[lang].expenses}</h6>
                            </div>
                        </div>
                    </div>
                    <div className="col-3">
                        <div className="card bg-success text-white mb-4 sale">
                            <div><ExpensesIcon fill="#fff" strokeWidth="1" /></div>
                            <div className="card-body text-center">
                                <h4>{parseInt(widgetData.storeExpenses).toLocaleString()}<sup className="card-currency">{currency}</sup> </h4>
                                <h6 className="mb-0">{translation[lang].storeExpenses}</h6>
                            </div>
                        </div>
                    </div>
                    <div className="col-3">
                        <div className="card bg-success text-white mb-4 sale">
                            <div><ProfitIcon fill="#fff" strokeWidth="1" /></div>
                            <div className="card-body text-center">
                                <h4>{parseInt(widgetData.profit).toLocaleString()}<sup className="card-currency">{currency}</sup> </h4>
                                <h6 className="mb-0">{translation[lang].profit}</h6>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="graph pt-1 pb-5 rounded">
                    <ResponsiveContainer width="100%" height={window.innerHeight / 2} className="mt-5">
                        <LineChart
                            // width={700}
                            // height={400}
                            data={currentData}
                            style={{ overflow: 'visible' }}
                            margin={{ top: 0, right: 30, left: 20, bottom: 25 }}
                        >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="name" height={60} tick={<CustomizedAxisTick lang={lang} period={period} />} />
                            <YAxis allowDecimals tickFormatter={(value) => value.toLocaleString()} />
                            <Tooltip
                                formatter={(value, name, props) => ([value.toLocaleString(), translation[this.props.lang || 'uz'][name.toLowerCase()]])}
                                labelFormatter={value => {
                                    if (period === 'current') {
                                        return translation[this.props.lang || 'uz'][value.toLowerCase()]
                                    } else if (period === 'quater') {
                                        return translation[this.props.lang || 'uz'][value.toLowerCase()]
                                    } else if (period === 'semiannual') {
                                        return translation[this.props.lang || 'uz'][value.toLowerCase()]
                                    } else if (period === 'annual') {
                                        return translation[this.props.lang || 'uz'].short[value.toLowerCase()]
                                    } else {
                                        return value
                                    }
                                }}
                            />
                            <Legend formatter={(value) => translation[this.props.lang || 'uz'][value.toLowerCase()]} />
                            <Line type="monotone" strokeWidth={2} dataKey="sale" stroke="#8884d8" label={<CustomizedLabel lang={lang} period={period} />} />
                            <Line type="monotone" strokeWidth={2} dataKey="expenses" stroke="#e91e63" label={<CustomizedLabel lang={lang} period={period} />} />
                            <Line type="monotone" strokeWidth={2} dataKey="profit" stroke="#82ca9d" label={<CustomizedLabel lang={lang} period={period} />} />
                        </LineChart>
                    </ResponsiveContainer>
                </div>
            </div>
        );
    }
}
export default Profit;